<template>
  <div class="px-5 pb-5">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-7">
        <h3 class="font-weight-bold mb-3">
          Metti all'opera agenzie e imprese
        </h3>
        <p class="h5 mb-5">
          I migliori operatori sul territorio sono pronti ad ascoltare le tue esigenze e ad offrirti
          una consulenza mirata e personalizzata!
        </p>
      </div>
      <div class="col-12 col-sm-6 col-md-5">
        <div class="form-group">
          <label class="text-primary mb-0">Telefono</label>
          <input
            class="form-control textfield"
            type="phone"
            v-model="ricerca.contatto_telefonico"
            required
          >
        </div>

        <div class="d-flex mt-3">
          <button
            class="btn btn-primary w-50"
            :disabled="$v.$invalid"
            data-gtm-event="ricerca_salvata_telefono"
            :data-source="source"
            @click="$emit('next-step')"
          >
            Sì, iniziamo subito
          </button>

          <button
            class="btn btn-outline-primary d-flex justify-content-center ml-3 flex-grow-1"
            data-gtm-event="ricerca_salvata_no_telefono"
            :data-source="source"
            @click="onCloseWizard"
          >
            Magari più avanti
            <i
              class="fas fa-sign-out-alt ml-3"
              data-gtm-event="ricerca_salvata_no_telefono"
              :data-source="source"
            ></i>
          </button>
        </div>
      </div>
    </div>

    <div class="border-left border-primary citazione mt-5 px-5 py-4">
      <em>
        In Italia il 90% di vendite e/o affitti sono conclusi grazie all’intervento di un Agente Immobiliare. Avvalersi
        di un operatore preparato su leggi e fisco, capace di mediare tra le parti e in possesso di una selezionata
        banca dati immobiliare è il modo migliore per trovare casa.
      </em>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'SalvaRicercaTelefono',

  props: ['utente', 'ricerca', 'source'],

  mixins: [validationMixin],

  validations: {
    ricerca: {
      contatto_telefonico: { required }
    }
  },

  methods: {
    onCloseWizard () {
      Swal.fire({
        text: 'Ok, controlla quotidianamente la tua mail per visualizzare le nuove proposte prima degli altri.',
        type: 'success'
      }).then(() => {
        this.$emit('closemodal')
      });
    }
  }
}
</script>

<style
  lang="scss"
  scoped
>
.citazione {
  background-color: #f0f0f0;
  font-weight: 600;
  border-left: 3px solid;
}

button {
  align-items: baseline;
}

.form-group {
  label {
    font-weight: 600;
  }

  input {
    border-radius: 0;
  }
}
</style>
